module.exports = __webpack_public_path__ + "img/16.4293b452.jpg";